<template>
<div id="reports">
    <vue-headful title="Reports" />
    <v-container fluid style="background-color: #f5f5f5;" :class="{ 'px-1': $vuetify.breakpoint.smAndDown, 'pt-3': true}">
        <div>
            <div class="important ml-2">
                Hoteluri
            </div>
            <v-card class="ma-2" width="100%" flat style="border-bottom: 1px solid #9b9b9b">
                <div class="d-flex justify-space-between align-center">
                    <div class="regular ml-3">
                        Evidența tuturor hotelurilor
                    </div>
                    <im-download slot="activator" type="xls" name="hotels.xls" :fields="item_headers_hotels" ref="hotels">
                        <v-btn text icon v-if="!download_loading_hotels" @click="getDownloadHotels()">
                            <v-icon :large="$vuetify.breakpoint.smAndUp" style="transform: rotate(180deg);">publish</v-icon>
                        </v-btn>
                        <v-progress-circular v-if="download_loading_hotels" indeterminate color="primary"></v-progress-circular>
                    </im-download>
                </div>
            </v-card>
            <v-card class="ma-2" width="100%" flat style="border-bottom: 1px solid #9b9b9b">
                <div class="d-flex justify-space-between align-center">
                    <div class="regular ml-3">
                        Raport disponibilitate
                    </div>
                    <v-btn text icon @click="openHotelInventory()">
                        <v-icon :large="$vuetify.breakpoint.smAndUp" style="transform: rotate(180deg);">publish</v-icon>
                    </v-btn>
                </div>
            </v-card>

            <div class="important ml-2">
                Rezervări
            </div>
            <v-card class="ma-2" width="100%" flat style="border-bottom: 1px solid #9b9b9b">
                <div class="d-flex justify-space-between align-center">
                    <div class="regular ml-3">
                        Evidența tuturor rezervărilor
                    </div>
                    <im-download slot="activator" type="xls" name="reservations.xls" :fields="item_headers_reservations" ref="reservation">
                        <v-btn text icon v-if="!download_loading_reservation" @click="getDownloadReservations()">
                            <v-icon :large="$vuetify.breakpoint.smAndUp" style="transform: rotate(180deg);">publish</v-icon>
                        </v-btn>
                        <v-progress-circular v-if="download_loading_reservation" indeterminate color="primary"></v-progress-circular>
                    </im-download>
                </div>
            </v-card>
        </div>
        <div class="important ml-2">
            Facturi
        </div>
        <!-- issue date data filter-->
        <v-card class="elevation-1 pa-1 ma-2" max-width="460px">
            <div class="title-filter">Perioada emiterii</div>
            <div class="d-flex">
                <v-menu transition="scale-transition" offset-y>
                    <template v-slot:activator="{ on }">
                        <v-text-field v-on="on" class="im-select ma-0" flat solo required readonly placeholder="After ..." v-model="comp_issue_date_from" return-object hide-details></v-text-field>
                    </template>
                    <v-date-picker v-model="issue_date_from" no-title width="265">
                        <v-spacer></v-spacer>
                        <v-btn flat color="red" @click="issue_date_from = null;">Clear date</v-btn>
                    </v-date-picker>
                </v-menu>
                <v-icon small class="mx-1">arrow_forward</v-icon>
                <v-menu transition="scale-transition" offset-y>
                    <template v-slot:activator="{ on }">
                        <v-text-field v-on="on" class="im-select ma-0" flat solo required readonly placeholder="Before ..." v-model="comp_issue_date_to" hide-details></v-text-field>
                    </template>
                    <v-date-picker v-model="issue_date_to" :min="issue_date_from" no-title width="265">
                        <v-spacer></v-spacer>
                        <v-btn flat color="red" @click="issue_date_to = null;">Clear date</v-btn>
                    </v-date-picker>
                </v-menu>
            </div>
        </v-card>
        <!--./ issue date data filter-->
        <v-row no-gutters class="mt-5">
            <v-col cols="12" md="6" class="px-2">
                <v-card width="100%" flat style="border-bottom: 1px solid #9b9b9b">
                    <div class="d-flex justify-space-between align-center">
                        <div class="regular mx-3">
                            Export facturi fiscale (hoteluri)
                        </div>
                        <div>
                            <v-btn class="ma-1" :icon="$vuetify.breakpoint.xs" :small="$vuetify.breakpoint.xs" text :disabled="getReports()" @click="downloadInvoices('hotels','csv')">
                                <span v-if="$vuetify.breakpoint.smAndUp">csv</span>
                                <v-icon :large="$vuetify.breakpoint.smAndUp" class="pl-2">table_chart</v-icon>
                            </v-btn>
                            <v-btn class="ma-1" :icon="$vuetify.breakpoint.xs" :small="$vuetify.breakpoint.xs" text :disabled="getReports()" @click="downloadInvoices('hotels','zip')">
                                <span v-if="$vuetify.breakpoint.smAndUp">zip</span>
                                <v-icon :large="$vuetify.breakpoint.smAndUp" class="pl-2">archive</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </v-card>
            </v-col>
            <v-col cols="12" md="6" class="px-2">
                <v-card width="100%" flat style="border-bottom: 1px solid #9b9b9b">
                    <div class="d-flex justify-space-between align-center">
                        <div class="regular mx-3">
                            Export facturi proforme (agentii)
                        </div>
                        <div>
                            <v-btn class="ma-1" :icon="$vuetify.breakpoint.xs" :small="$vuetify.breakpoint.xs" text :disabled="getReports()" @click="downloadInvoices('organizations','csv')">
                                <span v-if="$vuetify.breakpoint.smAndUp">csv</span>
                                <v-icon :large="$vuetify.breakpoint.smAndUp" class="pl-2">table_chart</v-icon>
                            </v-btn>
                            <v-btn class="ma-1" :icon="$vuetify.breakpoint.xs" :small="$vuetify.breakpoint.xs" text :disabled="getReports()" @click="downloadInvoices('organizations','zip')">
                                <span v-if="$vuetify.breakpoint.smAndUp">zip</span>
                                <v-icon :large="$vuetify.breakpoint.smAndUp" class="pl-2">archive</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</div>
</template>
<script>
import Download from '../components/utils/Download.vue';

export default {
    name: `reports`,

    components: {
        'im-download': Download
    },

    data() {
        return {
            // date filters
            issue_date_from: null,
            issue_date_to: null,

            // table attributes
            loading: null,
            total: 0,
            pagination: null,

            rppi: [10, 25, 50, 100],

            //excel download
            download_loading_reservation: false,
            download_loading_hotels: false,

            item_headers_reservations: {
                'Booking Code': 'id',
                'Status': 'status',
                'Nume hotel': 'hotel_contact.name',
                'Regiune hotel': 'hotel_contact.region',
                'Creat': 'timestamp',
                'Check-In': 'check_in',
                'Check-Out': 'check_out',
                'Nopti': 'nights',
                'Camere': 'rooms',
                'Camere-Nopti': 'rooms_nights',
                'Pret total': 'pricing.total',
                'Pret final': 'pricing.after_tax',
                'Moneda Hotel': 'pricing.currency',
                'Total EUR': 'pricing.total_eur',
                'Nume agentie': 'agency.name',
                'Procentaj comision': 'agency.commissioning.agency.commission_percentage',
                'Comisionul agentiei': 'agency.commissioning.agency.commission_value',
                'Nume client': 'client_contact.last_name',
                'Prenume client': 'client_contact.first_name',
                'Email client ': 'client_contact.contact.email',
                'Client telefon': 'client_contact.contact.phone',
                'Hotel Contact Email': 'hotel_contact.contact_email',
                'Hotel Email': 'hotel_contact.email',
                'Hotel telefon': 'hotel_contact.phone'
            },
            item_headers_hotels: {
                'Numele Hotelului': 'name',
                'Judet': 'region',
                'Oras': 'city',
                'Adresa': 'address',
                'Geolocalizare latitudine': 'latitude',
                'Geolocalizare longitudine': 'longitude',
                'Status': 'status',
                'Tipul Unitatii': 'unit_type',
                'Certificat clasificare': 'classification_number',
                'Certificat Status': 'classification_status',
                'Test flag': 'test',
                'Contact Email': 'contact.contact_email',
                'Phone': 'contact.phone',
                'Hotel Email': 'contact.email'
            },


        }
    },
    computed: {
        comp_issue_date_from: {
            get: function () {
                return this.formatDate(this.issue_date_from);
            },
            set: function (val) {
                return (this.issue_date_from = val);
            }
        },
        comp_issue_date_to: {
            get: function () {
                return this.formatDate(this.issue_date_to);
            },
            set: function (val) {
                return (this.issue_date_to = val);
            }
        }
    },

    methods: {

        openHotelInventory() {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SSR_CONSOLE + '/statistics/all-hotels-inventory-sum';
            window.open(endpoint, "_blank");
        },

        getDownloadReservations() {

            this.download_loading_reservation = true;

            // prepare stamp & save current_stamp
            let stamp = Date.now();
            this.current_stamp = stamp;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/admin/reservations";

            // setup query params
            let params = {
                params: {
                    size: 10000,
                    stamp: stamp,
                }
            };

            this.$axios.get(endpoint, params)
                .then(response => {
                    let items = response.data.data;
                    items.forEach(function (element, index) {

                        if(element.status === "booked") {
                            items[index].status = "Rezervat";
                        }
                        if(element.status === "no-show") {
                            items[index].status = "Neprezentat";
                        }
                        if(element.status === "canceled") {
                            items[index].status = "Anulat";
                        }
                        if(element.client_contact.phone === null) {
                            items[index].client_contact.phone = "";
                        }
                        if(element.hotel_contact.contact_email === null) {
                            items[index].hotel_contact.contact_email = "";
                        }
                        if(element.is_agency === false) {
                            let commission = {
                                'commissioning': {
                                    'agency': {
                                        'commission_percentage': "",
                                        'commission_value': ""
                                    }
                                }
                            };
                            items[index].agency = commission;
                        } else {
                            if(element.agency.commissioning === null) {
                                let commission = {
                                    'commissioning': {
                                        'agency': {
                                            'commission_percentage': "",
                                            'commission_value': ""
                                        }
                                    }
                                };
                                items[index].agency = commission;
                            }
                            if(element.agency.commissioning.agency && element.agency.commissioning.agency.commission_value) {
                                items[index].agency.commissioning.agency.commission_value = "&#8203;" + items[index].agency.commissioning.agency.commission_value;
                            }
                        }
                        if(element.agency.name === null || element.agency.name === undefined) {
                            items[index].agency.name = "";
                        }

                        items[index].timestamp = this.$moment(element.timestamp * 1000)
                            .format('DD-MM-YYYY');
                        items[index].check_in = this.$moment(element.check_in * 1000)
                            .format('DD-MM-YYYY');
                        items[index].check_out = this.$moment(element.check_out * 1000)
                            .format('DD-MM-YYYY');

                    }.bind(this));
                    this.$refs.reservation.generate(items);
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.download_loading_reservation = false;
                });
        },

        getDownloadHotels() {
            this.download_loading_hotels = true;

            // prepare stamp & save current_stamp
            let stamp = Date.now();
            this.current_stamp = stamp;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/admin/hotels";

            // setup query params
            let params = {
                params: {
                    size: 10000,
                    stamp: stamp,
                }
            };

            this.$axios.get(endpoint, params)
                .then(response => {
                    let items = response.data.data;
                    items.forEach(function (element, index) {
                        if(element.region === null) {
                            items[index].region = '';
                        }
                        if(element.classification_number === null) {
                            items[index].classification_number = '';
                        }
                        if(element.classification_status === null) {
                            items[index].classification_status = '';
                        }
                        if(element.contact_email === null) {
                            items[index].contact_email = '';
                        }
                    });
                    this.$refs.hotels.generate(items);
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.download_loading_hotels = false;
                });
        },

        downloadInvoices(item, type) {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_INVOICES + "/api/invoices/" + item + "/" + type + "?start=" + this.issue_date_from + "&stop=" + this.issue_date_to;
            window.open(endpoint, "_blank");
        },

        formatDate(value) {
            if(!value) return value;
            return this.$moment(String(value))
                .format("D MMM YY");
        },

        getReports() {
            return (this.issue_date_to == null || this.issue_date_from == null);
        },

    }
}
</script>
